<mat-toolbar fxLayout="row" fxLayoutAlign="start center" style="margin-top: 1%;">

    <div fxLayout="row" fxFlex="15" fxFlexOffset="5">
        <div class="sidenav-img" fxLayoutAlign="center center">
            <a [routerLink]="'/admin'">
                <img src="assets/side-nav-logo.svg" />
            </a>
        </div>
    </div>

    <div fxLayout="row" class="admin-header" fxLayoutAlign="space-between center" fxFlex="76">
        <!-- <div fxLayout="row" fxFlex="30" fxLayoutAlign="start center" fxLayoutGap="15px" >
            <label class="admin-label">Admin Panel</label>
            
        </div> -->
        <span class="example-spacer"></span>
        <div fxLayout="row" fxLayoutAlign="end center">
            <div class="header-div" fxLayout="column">
                <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="20px">
                    <img class="user-header-image" src="assets/admin-img.svg">
                    <div fxLayout="column" fxLayoutAlign="space-between center">
                        <label class="admin-name">Admin 1</label>

                    </div>
                    <div>
                        <button type="button" fxLayoutAlign="center center" class="downarrow-btn" color="primary"
                            [matMenuTriggerFor]="beforeMenu"><i class="fa fa-angle-down"
                                aria-hidden="true"></i></button>
                        <div>
                            <mat-menu #beforeMenu="matMenu" xPosition="before" style="padding: 0 !important;">
                                <div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="5px">
                                    <div fxLayout="column" style="padding:0px 40px;" fxLayoutAlign="center center">
                                        <img width="70" height="70" style="border-radius: 50px;"
                                            src="assets/user-profile1-icon.svg">
                                        <!-- <h6 class="user-name"> {{merchantDetails && merchantDetails.name}}</h6> -->
                                        <p class="user-email">{{loginAdminDetails?.email}}</p>
                                        <!-- <a class="manage-account" [routerLink]="'/edit-profile'">Manage Account</a> -->
                                    </div>

                                    <div fxLayout="column" fxFlex="15"
                                        style="background: #F4F6FA;padding:1%;width: 100%;">
                                        <button type="button" class="signout-btn" fxLayoutAlign="center center"
                                            (click)="logout()">Sign Out
                                        </button>
                                    </div>
                                </div>
                            </mat-menu>
                        </div>
                    </div>

                </div>

            </div>

        </div>
    </div>

    <div fxFlex="4"></div>


</mat-toolbar>
<div style="display: flex;justify-content: space-evenly;width: 35%;">
    <div class="admin-label" (click)="changeType(1)" [ngStyle]="selectedSection==1 && {'font-weight': '900'}">Admin Panel
        <div *ngIf="selectedSection==1" style="width: 85px; height: 0px; border: 1px #386AF6 solid"></div>
    </div>
    <div class="social-hub-label" (click)="changeType(2)" [ngStyle]="selectedSection==2 && {'font-weight': '900'}">Social
        Hub
        <div *ngIf="selectedSection==2" style="width: 75px; height: 0px; border: 1px #386AF6 solid"></div>
    </div>
    <div class="social-hub-label" (click)="changeType(3)" [ngStyle]="selectedSection==3 && {'font-weight': '900'}">Create
        <div *ngIf="selectedSection==3" style="width: 45px; height: 0px; border: 1px #386AF6 solid"></div>
    </div>
    <div class="social-hub-label" (click)="changeType(4)" [ngStyle]="selectedSection==4 && {'font-weight': '900'}">Banner Hub
        <div *ngIf="selectedSection==4" style="height: 0px; border: 1px #386AF6 solid"></div>
    </div>
</div>

<router-outlet></router-outlet>